module.exports = ".marginTop {\n  margin-top: 30px; }\n"